import { gql } from '@apollo/client';

export const OPTIONALS = gql`
  query getAvailableOptionals($inputOptional: String!, $inputModelVersions: [String!]) {
    getAvailableOptionals(inputOptional: $inputOptional, inputModelVersions: $inputModelVersions)
  }
`;
